import { render } from "./MyAccount.vue?vue&type=template&id=6f02746b&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"

import "./MyAccount.vue?vue&type=style&index=0&id=6f02746b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f02746b"]])

export default __exports__